module.exports = __webpack_public_path__ + "img/sundry_market.754124a7.jpg";